import React, {useCallback, useRef} from 'react';

import {Box} from '@buncha/components/core/view';
import {Config} from '@buncha/utils/types';
import {PSmallText} from '@buncha/components/core/text';
import {StorageKeys} from '@buncha/config/storage/type';
import {Touchable} from '@buncha/components/core/touchable';
import {getConfig} from '@buncha/utils/appInfo';
import {storage} from '@buncha/config/storage';

const VersionPill = () => {
  const versionName = getConfig(Config.versionName);
  const numberOfTaps = useRef(0);

  const handleFiveTap = useCallback(() => {
    numberOfTaps.current = 0;
    storage.setItem(StorageKeys.meijerDebug, 'true');
  }, []);

  const handleTap = useCallback(async () => {
    if (numberOfTaps.current < 5) numberOfTaps.current += 1;
    else handleFiveTap();
  }, [handleFiveTap]);
  return (
    <Touchable
      onPress={handleTap}
      hitSlop={{
        top: 50,
        bottom: 50,
        left: 50,
        right: 50,
      }}>
      <Box>
        <PSmallText>{versionName}</PSmallText>
      </Box>
    </Touchable>
  );
};

export default React.memo(VersionPill);
